var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"error-message flex"},[_c('span',{staticClass:"fas fa-exclamation-triangle mt4 mr7"}),_c('span',[_vm._v(_vm._s(_vm.errorMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }